import SEO from "components/seo/SEO";

const Custom404 = () => {
  const seo = () => {
    return <SEO seoTitle={"404 - Side ikke funnet"} />;
  };

  return (
    <>
      {seo()}
      <div className="container my-24">
        <div className="max-w-3xl">
          <h1 className="text-Hl md:text-H2xl ">404 - Finner ikke siden</h1>
        </div>
      </div>
    </>
  );
};

export default Custom404;
